import { getServicePrice } from "./utils";

export function trackViewItem(skus, state) {
    if (skus && skus.length > 0) {
        const eCommerceItems = skus.map((val, index) => { return skuToEcommerceItem(val, index + 1, state) });
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ 'ecommerce': null });
        window.dataLayer.push({
            event: 'view_item_list',
            ecommerce: {
                items: eCommerceItems
            }
        });
    }
}

export function trackSelectItem(selectedSku, state) {
    if (selectedSku && state) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ 'ecommerce': null });
        window.dataLayer.push({
            event: 'select_item',
            garage: getSelectedStationName(state),
            ecommerce: {
                items: [skuToEcommerceItem(selectedSku, 1, state)]
            }
        });
    }
}

export function trackAddToCart(state) {
    if (state) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ 'ecommerce': null });
        window.dataLayer.push({
            event: 'add_to_cart',
            garage: getSelectedStationName(state),
            currency: 'CHF',
            value: 0, // Wenn Wert vorhanden ist, mit Punkttrennung z.B.: 35.25
            ecommerce: {
                items: getCurrentSelectedEcommerceItems(state)
            }
        });
    }
}

export function trackBeginCheckout(state) {
    if (state) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ 'ecommerce': null });
        window.dataLayer.push({
            event: 'begin_checkout',
            garage: getSelectedStationName(state),
            currency: 'CHF',
            value: 0, // Wenn Wert vorhanden ist, mit Punkttrennung z.B.: 35.25
            ecommerce: {
                items: getCurrentSelectedEcommerceItems(state)
            }
        });
    }
}

export function trackAddShippingInfo(state) {
    if (state) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ 'ecommerce': null });
        window.dataLayer.push({
            event: 'add_shipping_info',
            garage: getSelectedStationName(state),
            zip: state.zipcode,
            currency: 'CHF',
            value: 0, // Wenn Wert vorhanden ist, mit Punkttrennung z.B.: 35.25
            ecommerce: {
                items: getCurrentSelectedEcommerceItems(state)
            }
        });
    }
}

export function trackPurchase(state) {
    if (state) {
        const transactionId = Date.now().toString(); // since there is no transaction id, we generate a "random" one, which looks like: 1741352602613
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ 'ecommerce': null });
        window.dataLayer.push({
            event: 'purchase',
            garage: getSelectedStationName(state),
            zip: state.zipcode,
            currency: 'CHF',
            value: 0, // Wenn Wert vorhanden ist, mit Punkttrennung z.B.: 35.25
            transaction_id: transactionId, // Eindeutige TransactionID
            transaction_type: 'offerte',
            ecommerce: {
                items: getCurrentSelectedEcommerceItems(state)
            }
        });
    }
}

// --- helpers: ---

function getCurrentSelectedEcommerceItems(state) {
    var result = [];
    if (state.selectedTyre) {
        result.push(skuToEcommerceItem(state.selectedTyre, 1, state));
        const bookedServices = state.settings['Services'].filter(service => service.IsBooked);
        bookedServices.forEach((s) => {
            result.push(serviceToEcommerceItem(s, getServicePrice(s, state), state.selectedTyre.CarType));
        });
    }
    return result;    
}

function skuToEcommerceItem(sku, itemIndex, state) {
    const itemPrice = sku.DiscountPrice ? sku.DiscountPrice : sku.Price;
    return {
        item_name: sku.Title, // Produktname in Shopsprache
        item_id: sku.EAN.toString(), // �bergeordnete ID f�r Reifen
        price: itemPrice, // Wenn Preis vorhanden ist, mit Punkttrennung z.B.: 35.25
        item_brand: sku.BrandName, // Brand des Produktes - falls nicht vorhanden 'migrol'
        item_category: 'Reifen', // z.B. Reifen
        item_variant: sku.Description, // Produktvariante, wenn vorhanden - falls nicht, bitte weg lassen
        quantity: state.tyreAmount,
        index: itemIndex, // Position der Produkte auf der Seite (1, 2, 3)
        vehicle_type: sku.CarType, // PKW oder SUV oder Van/Transporter
        tyres_season: sku.Season // Jahr in dem die Reifen hergestellt wurden
    }
}

function serviceToEcommerceItem(service, servicePrice, carType) {
    return {
        item_name: service.Title, // Produktname in Shopsprache, z.B. Komplettmontage
        item_id: service.ID, // �bergeordnete ID f�r Zusatzservices
        price: servicePrice, // Wenn Preis vorhanden ist, mit Punkttrennung z.B.: 35.25
        item_brand: 'migrol', // Brand des Produktes - falls nicht vorhanden 'migrol'
        item_category: 'Zusatzservices', // z.B. Zusatzservices
        quantity: 1, // Menge
        vehicle_type: carType // PKW oder SUV oder Van/Transporter
    }
}

function getSelectedStationName(state) {
    if (state && state.selectedStationId) {
        return state.settings['AvailableStations'].find(s => s.id == state.selectedStationId).text;
    } else {
        return '';
    }
}